module.exports = "/assets/site/images/cseh_tamas_portfoli.jpg?5ef4bd591be2103ebff57459ebaf3ddc";